import { AccommodationSpecificity } from '@silbo/core';
import {
  AccommodatedIcon,
  CovidIcon,
  HourglassIcon,
  IsolatedAirIcon,
  IsolatedContactIcon,
  IsolatedDropletIcon,
  IsolatedIcon,
  IsolatedProtectorIcon,
  PrivateRoomIcon,
} from '@silbo/ui';

import { ReactElement } from 'react';

export const specificityColor: Record<AccommodationSpecificity, 'warning' | 'error' | 'primary' | 'info' | 'danger'> = {
  COVID: 'error',
  ACCOMMODATED: 'warning',
  ISOLATED: 'danger',
  ISOLATED_AIR: 'danger',
  ISOLATED_DROPLET: 'danger',
  ISOLATED_CONTACT: 'danger',
  ISOLATED_PROTECTOR: 'danger',
  PRIVATE_ROOM: 'info',
  WAITING_FOR_DOWNSTREAM_BED: 'primary',
};

export const specificityIcon: Record<AccommodationSpecificity, ReactElement> = {
  COVID: <CovidIcon />,
  ACCOMMODATED: <AccommodatedIcon />,
  ISOLATED: <IsolatedIcon />,
  ISOLATED_AIR: <IsolatedAirIcon />,
  ISOLATED_DROPLET: <IsolatedDropletIcon />,
  ISOLATED_CONTACT: <IsolatedContactIcon />,
  ISOLATED_PROTECTOR: <IsolatedProtectorIcon />,
  PRIVATE_ROOM: <PrivateRoomIcon />,
  WAITING_FOR_DOWNSTREAM_BED: <HourglassIcon />,
};
